/**
 * 用户信息
 * @param  {[type]} data 服务端原始数据
 * @return {[type]}      封装后的用户信息
 * {
    token: 专家token,
    avatar: 头像,
    name: 专家名称,
    title: 专家头衔,
    introduction: 专家简介,
  }
 */
export const userInfo = (data, member = null) => {
  if (!data.token || !data.encUserId) {
    console.error('值不能为空');
  }

  let avatar = 'http://img02.meituncdn.com/group1/M00/50/91/6d8d62509178446f8d20910ab801c53a.png';

  if (data.avatar) {
    avatar = data.avatar;
  } else if (data.avatarUrl) {
    avatar = data.avatarUrl;
  } else if (data.weixinUserInfo && data.weixinUserInfo.headimgurl) {
    avatar = data.weixinUserInfo.headimgurl;
  }
  return {
    encUserId: data.encUserId,
    token: data.token,
    avatar,
    name: data.name || data.nickName,
    isHaveMobile: data.isHaveMobile,
    weixinUserInfo: data.weixinUserInfo,
    member
  };
};

/**
 * 专家信息
 * @param  {[type]} data 服务端原始数据
 * @return {[type]}      封装后的专家信息
 * {
    token: 专家token,
    avatar: 头像,
    name: 专家名称,
    title: 专家头衔,
    introduction: 专家简介,
  }
 */
export const expertInfo = (data) => {
  if (!data.token || !data.expertName || !data.expertTitle || !data.introduction) {
    console.error('值不能为空');
  }
  return {
    id: data.id,
    token: data.token,
    avatar: data.avatarPic,
    name: data.expertName,
    title: data.expertTitle,
    introduction: data.introduction
  };
};

/**
 * 课程模型
 * @param  {[type]} data 课程服务端原始数据
 * @return {[type]}      封装后的课程模型
 * {
    id: 课程id,
    name: 课程名称,
    picture: 课程图片,
    star: 课程星级,
    startTime: 课程开始时间,
    joinNum: 听课人数,
    startStatus: 课程开始状态 0 未开始 1 已开始 2 已结束,
  }
 */
export const course = (data) => {
  if (!data.id || !data.name || !data.picture
    || !data.startTime) {
    console.error('值不能为空');
  }
  return {
    id: data.id,   // 课程id
    name: data.name,                   // 课程名称
    price: data.price,                 // 课程当前价格
    lastPrice: typeof data.lastPrice === 'undefined' ? data.listPrice : data.lastPrice, // 课程原价
    endPrice: data.afterPrice,         // 课程结束后价格
    picture: data.picture,             // 课程缩略图
    detailPicture: data.detailPicture, // 课程大图
    star: data.hot || 0,               // 课程评价等级
    startTime: data.startTime,         // 课程开始时间
    endTime: data.endTime,             // 课程结束时间
    currentTime: data.currentTime,     // 课程服务器时间
    joinNum: data.joinNum || 0,        // 课程参与人数
    joinNumDes: data.joinNumDes || '0',        // 课程参与人数
    likeNum: data.likeNum || 0,        // 课程喜欢人数
    hot: data.hot || 0,                 // 点评分数
    hasEndCourse: data.hasEndCourse,   // 课程结束
    startStatus: data.startStatus,     // 课程开始状态（0-未开始，1-已开始，2-已结束）
    status: data.status,               // 课程状态（1-未发布，2-已发布， 3-已取消）
    serialBuyType: data.serialBuyType, // 是否支持单独购买 0 支持单独购买   1 不支持单独购买
    join: data.join,                   // 是否购买了课程
    canJoin: data.canJoin,             // 是否能购买课程
    canComment: data.canComment,       // 是否可以评论
    canRecord: data.canRecord,         // 是否是录播 0非 1是
    expertName: data.expertName,       // 专家名称
    expertTitle: data.expertTitle,     // 专家头衔
    expertDesc: data.expertDesc,
    avatarPic: data.avatarPic,         // 专家头像
    courseDesc: data.courseDesc,       // 课程描述
    courseFeatures: data.courseFeatures,    // 课程介绍
    maxJoinNum: data.maxJoinNum,       // 课堂最大参与人数
    wsHost: data.wsHost,               // 课堂WebSocket链接地址
    wsPort: data.wsPort,               // 课堂WebSocket链接端口
    wssPort: data.wssPort,               // 课堂WebSocket链接 wss 端口
    canWsConn: data.canWsConn,               // 是否可以连接socket
    isMultiExpert: data.isMultiExpert, // 是否是多专家
    isManager: data.isManager, // 是否是管理员
    multiExpertDesc: data.multiExpertDesc, // 多专家信息
    hasBuy: data.hasBuy,   // 是否购买
    auditionStatus: data.auditionStatus,   // 是否试听
    labelDTOList: data.labelDTOList,    // 标签
    type: data.type,  // 课程类型0 普通课程   1 系列课程-主课程  2 系列课程-子课程
    expectCourseNum: data.expectCourseNum, // 第几期
    auditionUri: data.auditionUri || '',
    auditionUrl: data.auditionUrl || '',
    audioTime: data.audioTime || 0, // 音频/视频/健身课程 时长
    audioTimeStr: data.audioTimeStr || '', // 音频/视频/健身课程 时长描述
    auditionDuration: data.auditionDuration || 0,
    tinyCourseList: data.tinyCourseList || '',
    playNum: data.playNum || 0,
    featureLinks: data.featureLinks || [],
    featureModules: (data.courseFeatureDTO && data.courseFeatureDTO.featureModules) || data.featureModules || [],
    serialCourse: data.serialCourse || null,
    courseList: data.courseList,
    pointDTO: data.pointDTO,
    timeTag: data.timeTag,
    calories: data.calories || 0,
    supportAudition: data.supportAudition,
    playNumStr: data.playNumStr || '0',
    actualCourseNum: data.actualCourseNum, // 父课程包含的子课程数量
    distribution: data.distribution,         // 分销标志 0-不支持 1-支持
    distributionPrice: data.distributionPrice, // 分销佣金
    skuBenefitType: data.skuBenefitType, // 商品sku权益类型 0:普通商品，1:会员折扣商品，2:会员免费听商品"
    otherPrice: data.otherPrice, // skuBenefitType为1时才有意义
    vipLevel: data.vipLevel,
    jxjActiveDto: data.jxjActiveDto, // 奖学金课程对应信息
    materialType: data.materialType, // 媒体类型标签 1音频 2视频
    fileSize: data.fileSize,
    fileSizeStr: data.fileSizeStr
  };
};

/**
 * 新版课程模型 NEW
 * @param  {[type]} data 课程服务端原始数据
 * @return {[type]}      封装后的课程模型
 * {
    id: 课程id,
    name: 课程名称,
    picture: 课程图片,
    star: 课程星级,
    startTime: 课程开始时间,
    joinNum: 听课人数,
    startStatus: 课程开始状态 0 未开始 1 已开始 2 已结束,
  }
 */
export const newCourse = (data) => {
  if (!data.id || !data.name || !data.picture
    || !data.startTime) {
    console.error('值不能为空');
  }
  return {
    id: data.id,   // 课程id
    name: data.name,                   // 课程名称
    price: data.price,                 // 课程当前价格
    lastPrice: typeof data.lastPrice === 'undefined' ? data.listPrice : data.lastPrice, // 课程原价
    endPrice: data.afterPrice,         // 课程结束后价格
    picture: data.picture,             // 课程缩略图
    detailPicture: data.detailPicture, // 课程大图
    star: data.hot || 0,               // 课程评价等级
    startTime: data.startTime,         // 课程开始时间
    endTime: data.endTime,             // 课程结束时间
    currentTime: data.currentTime,     // 课程服务器时间
    joinNum: data.joinNum || 0,        // 课程参与人数
    joinNumDes: data.joinNumDes || '0',        // 课程参与人数描述
    likeNum: data.likeNum || 0,        // 课程喜欢人数
    hot: data.hot || 0,                 // 点评分数
    hasEndCourse: data.hasEndCourse,   // 课程结束
    startStatus: data.startStatus,     // 课程开始状态（0-未开始，1-已开始，2-已结束）
    status: data.status,               // 课程状态（1-未发布，2-已发布， 3-已取消）
    serialBuyType: data.serialBuyType, // 是否支持单独购买 0 支持单独购买   1 不支持单独购买
    join: data.join,                   // 是否购买了课程
    canJoin: data.canJoin,             // 是否能购买课程
    canComment: data.canComment,       // 是否可以评论
    canRecord: data.canRecord,         // 是否是录播 0非 1是
    expertName: data.expertName,       // 专家名称
    expertTitle: data.expertTitle,     // 专家头衔
    expertDesc: data.expertDesc,
    avatarPic: data.avatarPic,         // 专家头像
    courseDesc: data.courseDesc,       // 课程描述
    courseFeatures: data.courseFeatures || data.courseFeatureDTO,    // 课程介绍
    maxJoinNum: data.maxJoinNum,       // 课堂最大参与人数
    wsHost: data.wsHost,               // 课堂WebSocket链接地址
    wsPort: data.wsPort,               // 课堂WebSocket链接端口
    wssPort: data.wssPort,               // 课堂WebSocket链接 wss 端口
    canWsConn: data.canWsConn,               // 是否可以连接socket
    isMultiExpert: data.isMultiExpert, // 是否是联合主讲人
    isManager: data.isManager, // 是否是管理员
    multiExpertDesc: data.multiExpertDesc, // 多专家信息
    hasBuy: data.hasBuy,   // 是否购买
    auditionStatus: data.materials,   // 课程媒体信息 new add
    labelDTOList: data.labelDTOList,    // 标签       // 111该字段待确认
    type: data.type,  // 课程类型0 普通课程   1 系列课程-主课程  2 系列课程-子课程 3 普通微课  4 微课专辑  5微课子课程 9 视频-独立 10 视频专辑 11 视频-子课程 12 训练-独立课程 13 训练-系列 14 训练-子课程
    expectCourseNum: data.expectCourseNum, // 第几期
    auditionUri: data.auditionUri || '',
    auditionUrl: data.auditionUrl || '', // 试听音频/视频/健身课程
    auditionDuration: data.auditionDuration || 0,  // 试听音频/视频/健身课程 时长
    tinyCourseList: data.tinyCourseList || '',
    playNum: data.playNum || 0,
    featureLinks: data.featureLinks || [],
    // featureModules: data.featureModules || [],
    featureModules: data.courseFeatureDTO.featureModules || [],   // 课程特色 new add
    serialCourse: data.serialCourse || null,     // 新修改的
    courseList: data.courseList,
    pointDTO: data.pointDTO,            // 积分信息抵扣信息
    timeTag: data.timeTag,              // 组合课详情页倒计时标
    calories: data.calories || 0,       // 训练课程消耗热量
    supportAudition: data.supportAudition,
    playNumStr: data.playNumStr || '0',
    actualCourseNum: data.actualCourseNum, // 父课程包含的子课程数量
    detailTabs: data.detailTabs || [],           // 详情页Tab
    canUseNumStr: data.canUseNumStr, // 快问医生使用次数
    distribution: data.distribution,         // 分销标志 0-不支持 1-支持
    distributionPrice: data.distributionPrice, // 分销佣金
    skuBenefitType: data.skuBenefitType, // 商品sku权益类型 0:普通商品，1:会员折扣商品，2:会员免费听商品"
    otherPrice: data.otherPrice, // skuBenefitType为1时才有意义
    vipLevel: data.vipLevel,
    subStatus: data.subStatus, // 订阅课更新状态 0:未完结,1：已完结
    subMaterialType: data.subMaterialType, // 订阅课媒体类型标签 0"图文" 1"音频" 2"视频" 3"图文+音频" 4"图文+视频" 5"音频+视频"
    subMaterialTypeDesc: data.subMaterialTypeDesc, // 订阅课媒体类型标签
    materialType: data.materialType, // 媒体类型标签 1音频 2视频
    courseNotice: data.courseNotice, // 订阅课预告
    jxjActiveDto: data.jxjActiveDto, // 奖学金课程对应信息
    fileSize: data.fileSize,
    fileSizeStr: data.fileSizeStr
  };
};

/**
 * 图片模型
 * @param  {[type]} data 课程服务端原始数据
 * @return {[type]}      返回封装后的图片模型
 * {
    "id": 图片id,
    "url": 图片url,
    "createTime": 创建时间,
  }
 */
export const picture = (data) => {
  if (!data.id || !data.picUrl || !data.createTime) {
    console.error('值不能为空');
  }
  return {
    index: data.sortIndex,
    id: data.id,
    url: data.picUrl,
    createTime: data.createTime
  };
};
/**
 * 图片模型
 * @param  {[type]} data 课程服务端原始数据
 * @return {[type]}      返回封装后的图片模型
 * {
    "id": 图片id,
    "url": 图片url,
    "createTime": 创建时间,
    "materialName": 文件名称,
    "fileSize": 文件大小,
    "duration": 声音时间,
  }
 */
export const audio = (data) => {
  if (!data.id || !data.picUrl || !data.createTime || !data.materialName) {
    console.error('值不能为空');
  }
  return {
    index: data.sortIndex,
    id: data.id,
    url: data.picUrl,
    createTime: data.createTime,
    name: data.materialName,
    fileSize: data.fileSize,
    duration: data.duration
  };
};

/**
 * 视频模型
 * @param  {[type]} data 课程服务端原始数据
 * @return {[type]}      返回封装后的图片模型
 * {
    "id": 视频id,
    "url": 视频url,
    "createTime": 创建时间,
    "materialName": 文件名称,
    "fileSize": 文件大小,
    "duration": 声音时间,
  }
 */
export const video = (data) => {
  if (!data.id || !data.picUrl || !data.createTime || !data.materialName) {
    console.error('值不能为空');
  }
  return {
    index: data.sortIndex,
    id: data.id,
    url: data.picUrl,
    img: data.thumbnail,
    createTime: data.createTime,
    name: data.materialName,
    fileSize: data.fileSize,
    duration: data.duration,
    width: data.width,
    height: data.height
  };
};

/**
 * 消息模型
 * @param  {[type]} data 原始服务端消息数据
 * @return {[type]}      返回封装后的消息模型
 *
 * {
    id: '消息id',
    courseId: '课程id',
    sender: { // 发送人信息
      id: 发送人id,
      name: 发送人姓名,
      avatar: 发送人头像,
      userType: 发送人类型,
    },
    type: 消息类型,
    content: 消息内容,
    thumbNail: 图片缩略图 ps：当消息为图片时,
    interestCount: 消息点赞次数,
    speech: 语音消息的时长,
    createTime: 消息发送时间,
    refMessage: { 当消息为回答时，该字段表示被回答的消息},
  }
 *
 */
export const message = (data) => {
  if (!data.id || !data.courseId || !data.senderName || !data.senderId
    || !data.avatarPic || !data.content || !data.createTime) {
    console.error('值不能为空');
  }
  let refMessage = null;
  if (data.refMessage) {
    refMessage = {
      content: data.refMessage.content
    };
  }
  return {
    id: data.id,
    courseId: data.courseId,
    sender: {
      id: data.senderId,
      encUserId: data.encUserId,
      name: data.senderName,
      avatar: data.avatarPic,
      userType: data.senderType
    },
    quickInsert: data.quickInsert,      // 发送消息，立即插入到消息队列
    clientSeqId: data.clientSeqId,
    type: data.type,
    content: data.content,
    thumbNail: data.thumbnail,
    interestCount: data.interestCount,
    speech: data.speech,
    createTime: data.createTime,
    refMessage,
    loadstartStatus: false, // 开始加载状态
    playingStatus: false, // 播放状态
    like: data.like || false,     // 是否喜欢这个问题，针对问题
    deleted: data.deleted || false,                   // 是否已经删除该条消息
    uploadStatus: 1,       // 默认录音上传为成功状态 1 默认状态  0 上传失败 2 插入了数据但是没有真正上传成功
    mediaId: null            // mediaId 默认为null
  };
};

/**
 * 签名模型
 * @param  {[type]} data 签名服务端原始数据
 * @return {[type]}      返回封装后的签名模型
 * {
    sign: 服务端签名值,
    timeStamp: 时间戳,
    userId: 签名用户id,
    userType: 签名用户类型,
  }
 */
export const sign = (data) => {
  if (!data.sign) {
    console.error('sign值不能为空');
  }
  return {
    sign: data.sign,
    timeStamp: data.timeStamp,
    userId: data.userId,
    userType: data.userType
  };
};


/**
 * 用户问题库模型
 * @param  {[type]} data 课程服务端原始数据
 * @return {[type]}      封装后的课程模型
 * {
    id: 课程id,
    name: 课程名称,
    picture: 课程图片,
    star: 课程星级,
    startTime: 课程开始时间,
    joinNum: 听课人数,
    startStatus: 课程开始状态 0 未开始 1 已开始 2 已结束,
  }
 */
export const userIssues = (data) => {
  if (!data.courseId || !data.id) {
    console.error('值不能为空');
  }
  return {
    id: data.id,  // 问题id
    cursorId: data.cursorId,   // 问题排行id
    courseId: data.courseId,   // 课程id
    type: data.type,    // 消息类型
    interestCount: data.interestCount,             // 多少人感兴趣
    createTime: data.createTime,                   // 消息提问时间
    content: data.content,     // 问题内容
    deleted: data.deleted,     // 消息是否被删除
    sender: { // 消息发送者消息
      id: data.senderId, // 发送者美囤id
      avatarPic: data.avatarPic,                   // 发送者头像
      name: data.senderName,   // 发送者名字
      type: data.senderType,   // 发送者类型
      like: data.like,  // 我是否关注
      encUserId: data.encUserId                   // 发送者宝宝树id
    },
    refMsg: { // 消息回复者消息
      id: data.refMsgId, // 回复id
      content: data.refMessage // 回复内容
    }
  };
};


/**
 * IM消息模型
 * @param  {[type]} data im服务端原始数据
 * @return {[type]}      封装后的im模型
 * {
     * msgType: 0-系统消息 1-图片 2-音频 3- 视频 4-时间消息 5-普通文字消息 6-图文消息.
     * from: 消息发送人
     * to: 消息接收人
     * text: 消息内容，仅系统消息、时间消息、普通文字消息有值
     * url: 图片或者音频消息的地址
     * urls: 图文消息的图片地址集合.
     * dur: 持续时常(录音文件专有字段)
     * time: 消息发送时间
     * status: 消息发送状态.
     * readFlag: 消息是否已读 true 已读消息.
     * questionId：问题id
     * questionType 1 问诊平台
     * roleType 发消息角色：1 医生端 2 用户端 3 系统消息
     * expertId 专家id
     * uid 用户uid
     * visibleType 消息可见性：1、全部可见 2、仅医生端可见 3、仅用户端可见
  }
 */
export const IMMsg = (data) => {
  const list = data.list;
  const newList = [];
  list.forEach((item) => {
    const msgType = item.msgType;
    let newMsgType = null;
    if (msgType === 1) {
      newMsgType = 5;
    } else if (msgType === 2) {
      newMsgType = 1;
    } else if (msgType === 3 || msgType === 4 || msgType === 26) {
      newMsgType = 2;
    } else if (msgType === 20) {
      newMsgType = 6;
    } else {
      newMsgType = 0;
    }
    const bodyJson = JSON.parse(item.bodyJson);
    const picUrls = [];
    if (bodyJson && bodyJson.attach && bodyJson.attach.attachments) {
      bodyJson.attach.attachments.forEach((urlItem) => {
        picUrls.push(urlItem.url);
      });
    }
    const msgInfo = {
      msgType: newMsgType,   // 主键id
      from: bodyJson.fromAccount, // `exp_${item.expertId}`, substr(1,url.length-1);
      to: item.uid,
      text: bodyJson && bodyJson.attach ? bodyJson.attach.content || bodyJson.attach.msg : bodyJson.body,
      url: bodyJson && bodyJson.attach ? bodyJson.attach.url : '',
      urls: picUrls,
      dur: bodyJson && bodyJson.attach ? bodyJson.attach.dur : '',
      questionId: item.id,
      roleType: item.roleType,
      expertId: item.expertId,
      uid: item.uid,
      visibleType: bodyJson.ext.visibleType
    };
    newList.push(msgInfo);
  });
  return {
    list: newList,
    hasNextPage: data.hasNextPage
  };
};



// WEBPACK FOOTER //
// ./src/comm/model/index.js